import { render } from "./index.vue?vue&type=template&id=4e5a87dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4e5a87dc"

export default script